var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",staticStyle:{"border-top":"0"},attrs:{"id":"footer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }